// 产品分类管理
import http from "@/jslibs/axios/http";

// 产品分类列表
export const list = (data) => http.get("/v1/cms/GoodsCategory", data);

// 产品分类新增
export const add = (data) => http.post("/v1/cms/GoodsCategory", data);

// 产品分类编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/GoodsCategory/${uuid}`, data);

// 产品分类删除
export const del = (data) => http.delete(`/v1/cms/GoodsCategory/${data.cuuid}`);

// 产品分类详情
export const detail = ({ cuuid, ...data }) => http.get(`/v1/cms/GoodsCategory/${cuuid}`, data);
